export default function QuestionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      style={{display:"block",height:"24px",width:"24px",fill:"currentColor"}}
      aria-hidden="true"
      role="presentation"
      focusable="false"
    >
      <path d="M16 1a15 15 0 1 0 15 15A15.02 15.02 0 0 0 16 1zm0 28a13 13 0 1 1 13-13 13.01 13.01 0 0 1-13 13zm1.5-5.5A1.5 1.5 0 1 1 16 22a1.5 1.5 0 0 1 1.5 1.5zM21.58 12c0 2.53-1.7 4.58-4.57 5.59L17 20h-2l.01-3.91.74-.2c1.15-.32 3.83-1.32 3.83-3.89a3.19 3.19 0 0 0-3.45-3.17 3.68 3.68 0 0 0-3.53 2.72L10.67 11a5.66 5.66 0 0 1 5.46-4.17A5.2 5.2 0 0 1 21.58 12z"></path>
    </svg>
  );
}
